import iconsMixin from './icons.js'
const icons = iconsMixin.data().icons

export default {
  data: function () {
    return {
      mainMenuItems: [
        /******************menu.json**************** */
        //To hide or show screens, within the menu.json file inside the items array, there
        //must always exist the form with the correct name. If wished to not show, then delete it.
        //Important: "Caption" and "Form" must be constant to one another. Caption comes from the server.ini file 
        //            and uses the only one "Form" value. If Form is changed then when the user turns on/off the flag in server.ini
        //            then the API ROUTER -->response will not update the menu.items[x] which is where the object is erased or not.
        //              *When ex: "personaliaBewerken" is off --> then in state.userInfo.loggedInUserInformation.menu.items will be deleted in array.
        //For ex:
        // {
        //   "Caption" : "ToonB",
        //   "Form" : "ScreenB",
        //   "Hint" : "ScreenB menu"
        // }, 
        /************************************** */
        {
          name: 'Agenda',
          icon: icons.CALENDAR,
          path: '/Agenda',
          _showInLandingPage: true,
          _bgColorInLandingPage: '#17a2b8',
          availableVwoAllUsers: true,
          // screenNameRoot: 'ScreenA',
          screenNameLeerling: 'Agenda'//comment out if this to not show in main menu
        },
        {
          name: 'Mijn gegevens',
          icon: icons.LISTVIEW,
          path: '/mijn-gegevens',
          _showInLandingPage: true,
          _bgColorInLandingPage: 'rgb(185, 13, 63)',
          availableVwoAllUsers: true,
          //  screenNameRoot: 'ScreenA', 
          screenNameLeerling: 'MijnGegevens'//comment out if this to not show in main menu or delete it in menu.json
        },
        {
          name: 'Aanwezigheden',
          icon: icons.CALENDAR_DOUBLE_CHECKED,
          path: '/Aanwezigheden',
          _showInLandingPage: true,
          _bgColorInLandingPage: 'rgb(220, 165, 0)',
          availableVwoAllUsers: true,
          // screenNameRoot: 'ScreenA',
          screenNameLeerling: 'Aanwezigheden'//comment out if this to not show in main menu
        },

        {
          name: 'Opleiding',
          icon: icons.COURSE,
          path: '/opleiding',
          _showInLandingPage: true,
          _bgColorInLandingPage: '#05789e',
          availableVwoAllUsers: true,
          // screenNameRoot: 'ScreenA',
          screenNameLeerling: 'Opleiding'//comment out if this to not show in main menu
        },



        {
          name: 'Betalingen',
          icon: icons.PAYMENT,
          path: '/betalingen',
          _showInLandingPage: true,
          _bgColorInLandingPage: '#98669e',
          availableVwoAllUsers: true,
          //  screenNameRoot: 'ScreenA',
          screenNameLeerling: 'Betalingen'
        },
        // {
        //   name: 'Module',
        //   icon: icons.COURSE,
        //   path: '/opleiding/module',
        //   _showInLandingPage: false,
        //   _bgColorInLandingPage: '#04489e',
        //  availableVwoAllUsers: true
        //  ,screenNameRoot: 'ScreenA',
        //  screenNameLeerling: 'ScreenA'
        // },

        {
          name: 'Website configuratie',
          icon: icons.LISTVIEW,
          path: '/configuratie',
          _showInLandingPage: true,
          _bgColorInLandingPage: '#06689e',
          availableRootUser: true,
          screenNameRoot: 'Beheerder',
          screenNameLeerling: 'Beheerder'
        },
        // {
        //   name: 'Mijn account',
        //   icon: icons.USERLOCKED,
        //   path: '/mijn-account',
        //   _showInLandingPage: true,
        //   _bgColorInLandingPage: 'rgb(228, 181, 22)',
        //  availableRootUser: true,
        //  screenNameRoot: 'Beheerder',
        //  screenNameLeerling: 'Beheerder'
        // },
        // {
        //   name: ' Mijn account',
        //   icon: icons.USERLOCKED,
        //   path: '/mijn-account',
        //   _showInLandingPage: true,
        //   _bgColorInLandingPage: 'rgb(228, 181, 22)',
        //  availableVwoAllUsers: true,
        //  screenNameRoot: 'ScreenA',
        //  screenNameLeerling: 'ScreenA' 
        // }



      ]
    }
  },
  methods: {
    // _userHasRightForThisScreen (screenName) {
    //   let defaultValue = this.$store.state.userInfo.loggedInUserInformation.rights.defaults
    //   let screenRights = this.$store.state.userInfo.loggedInUserInformation.rights.screens
    //   let toBeComparedBitwiseValue = null
    //   if (typeof screenRights[screenName] === 'undefined') {
    //     toBeComparedBitwiseValue = defaultValue
    //   } else {
    //     toBeComparedBitwiseValue = screenRights[screenName]
    //   }
    //   (toBeComparedBitwiseValue & 1) !== 0

    //   return true // for all types of screens
    // },

    _mainMenuItemsForLandingPage() {
      let self = this
      return this.mainMenuItems.filter(function (menuItem) {
        return menuItem._showInLandingPage && self._isMenuItemAvailableForLoggedInUser(menuItem)
      })
    },
    _mainMenuItemsForSideMenu() {
      let self = this
      let mainMenuItems = this.mainMenuItems.filter(function (menuItem) {
        return self._isMenuItemAvailableForLoggedInUser(menuItem)
      })

      return mainMenuItems
    },
    _isMenuItemAvailableForLoggedInUser(menuItem) {
      return ((this.$store.state.userInfo.isLeerkracht && menuItem.availableForLeerkrachten) ||
        (this.$store.state.userInfo.isLeerling && menuItem.availableForLeerlingen) ||
        (this.$store.state.userInfo.isVwoLogin && menuItem.availableVwoAllUsers) ||
        (this.$store.state.userInfo.isStudent && menuItem.availableVwoAllUsers) ||
        (this.$store.state.userInfo.isRootLogin && menuItem.availableRootUser) ||
        (this.$store.state.userInfo.isOuder && menuItem.availableForOuders))
        && this._leerlingOfOuderHasRightForThisScreen(menuItem)
    }
  }
}
